module.exports = __webpack_public_path__ + "static/media/box-ballot.4d852fe7.svg";